export default "__VITE_ASSET__1377e31b__"